<div class="estimator-container" [formGroup]="estimatorForm">
    <p class="description-text">{{'MENU_EDIT_PREFERENCES_ESTIMATOR_DESCRIPTION' | translate}}</p>

    <div class="row row-height align-items-center">
        <div class="col-sm-3">
            <label>{{'NAME' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="outline" class="full-width col-sm-12">
                <input matInput formControlName="name" (blur)="onBlur()">
            </mat-form-field>
        </div>
    </div>

    <div class="row row-height align-items-center">
        <div class="col-sm-3">
            <label>{{'EMAIL_ADDRESS' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="outline" class="full-width col-sm-12">
                <input matInput formControlName="emailAddress" (blur)="onBlur()">
            </mat-form-field>
        </div>
    </div>

    <div class="row row-height align-items-center">
        <div class="col-sm-3">
            <label>{{'USER_TYPE' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="outline" class="full-width col-sm-12">
                <mat-select formControlName="userType">
                    @for (item of userTypes; track item.id) {
                        <mat-option [value]="item.id">
                            {{item.description}}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>
